import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCRdhDtqY9Ikw9W1gQzcICLH00fgjiJtpk",
  authDomain: "depa-63c73.firebaseapp.com",
  databaseURL: "https://depa-63c73-default-rtdb.firebaseio.com",
  projectId: "depa-63c73",
  storageBucket: "depa-63c73.firebasestorage.app",
  messagingSenderId: "1039127798820",
  appId: "1:1039127798820:web:69ad7f191aad107cabe4b1",
  measurementId: "G-RK1XJYLLD8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export { database }; 